module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_03_stay-b394f162b3221f4eaaed6b679be8dace.jpg";